import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Observer, of, Subject, Subscription } from 'rxjs';
import { InsuranceService } from '../_services/insurance.services';
import { RequestService } from '../_services/request.services';
import { InterestService } from '../_services/interest.services';
import { exhaustMap } from 'rxjs/operators';
import { Policy } from '../_models/policy.model';
import { Document } from '../_models/document.model';
import { Interest } from '../_models/interest.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import _, { map } from 'underscore';
import JsFileDownloader from 'js-file-downloader';
import { HelperServices } from '../_services/helper.services';
import { I } from '@angular/cdk/keycodes';
import * as moment from 'moment';
import { RequestModel } from "../_models/request.model"

declare var download: any;
enum ErrorStates {
    NotSubmitted,
    HasError,
    NoError,
    CodeError,
    HasSuccess,
}

enum DocStates {
    HasError,
    NoError,
    HasEmpty,
    LoadingRequiredDocuments,
    LoadingUploadedDocuments,
    LoadingDocument,
    UploadingDocument
}

enum TrackStates {
    HasError,
    NoError,
    HasEmpty,
    Loading
};

import {
  GroupingState,
  PaginatorState,
  SortState,
  ICreateAction,
  IEditAction,
  IDeleteAction,
  IDeleteSelectedAction,
  IFetchSelectedAction,
  IUpdateStatusForSelectedAction,
  ISortView,
  IFilterView,
  IGroupingView,
  ISearchView,
} from '../../_metronic/shared/crud-table';
import { DocRequestService } from '../_services/docrequest.services';


@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent
  implements
  OnInit, 
  OnDestroy {
    loadingModalConfig: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false
    };
	largeModalConfig: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false,
		size 	 : 'xl'
    };
    errorStates = ErrorStates;
    errorState: ErrorStates = ErrorStates.NotSubmitted;
    docEstates = DocStates;
    doc1States: DocStates = DocStates.NoError;
    doc2States: DocStates = DocStates.NoError;
    upload1States: DocStates = DocStates.NoError;
    trackStates = TrackStates;
    trackState: TrackStates = TrackStates.NoError;

    loadingModal: boolean = false;
    paginator: PaginatorState;
    sorting: SortState;
    grouping: GroupingState;
    isLoading: boolean;
    templateView: number = 1;
    idSolicitud: number = 0;
    nroSolicitud: string = '';
    request_selected: RequestModel;
    myUploadedDocuments: any = null;
	
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user: UserModel;
    hasError: boolean;
    ramos: any;
    subramos: any;
    anyos: any;
    meses: any;
    endosos: any;
    companies: any;
    tiposEndosos;
    tipoGestiones:any;
    estatus: any;
    agencias: any;
    categorias: any;
    sucursales: any;
    agentes: any;
    lineanegocios: any;
    solicitudes: any;
    polizas: any;
    tipoFiltroInteres: any;
    insuredFilter: number = 0;
	documentos: any = Promise.resolve(null);
    showGestiones: any = Promise.resolve(null);
    sino: any;
    IdRamo: boolean = false;
    newRequest: any;
    filterPolicyForm: FormGroup;
    filterRequestForm: FormGroup;
    trackingForm: FormGroup;
    requestForm: FormGroup;
    requestDocumentsForm: FormGroup;
    closeResult: string;
    hasLoadindRD: boolean = false;
    permissionMenu: any;
    activeSubmitFilterPolicy: boolean = false;
    tracking_selected: any;

    private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    public  requiredDocument$: Observable<any>;
    private requiredDocumentSubject = new Subject<any>();

    public  uploadedDocuments$: Observable<any>;
    private uploadedDocumentsSubject = new Subject<any>();

    public  changeDocuments$:  Observable<any>;
    private changeDocumentsSubject = new Subject<any>();

    public  showDocuments$ = Promise.resolve(null);
    public  hideRequiredDocument$ = Promise.resolve(null);
    
    public  gestiones$: Observable<any>;
    private gestionesSubject = new Subject<any>();

    constructor(
        private layout: LayoutService,
        private auth: AuthService,
        private fb: FormBuilder,
        private modalRequest: NgbModal,
        private modalLoading: NgbModal,
        private modalRequiredDocumentos: NgbModal,
        private modalFilterPolicie: NgbModal,
        private modalStatus: NgbModal,
        private modalProcess: NgbModal,
        private modalTracking: NgbModal,
        public sanitizer: DomSanitizer,
        public requestService: RequestService,
        public docRequestService: DocRequestService,
        public helperService: HelperServices,
        public insuranceService: InsuranceService,
    ) {}
  
    // angular lifecircle hooks
    async ngOnInit() {
        this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];

        this.initForm();
    
        this.extrasUserDropdownStyle = this.layout.getProp(
            'extras.user.dropdown.style'
        );
        this.user$ = this.auth.currentUserSubject.asObservable();
        this.user$.subscribe(user=> {
            this._user = user;
        });

        this.changeDocuments$ = this.requiredDocumentSubject.asObservable();
        this.changeDocumentsSubject.next({state : DocStates.NoError});
        //this.changeDocumentsSubject.subscribe((event) => {return event});

        this.requiredDocument$ = this.requiredDocumentSubject.asObservable();
        this.requiredDocumentSubject.next(null);

        this.uploadedDocuments$ = this.uploadedDocumentsSubject.asObservable();
        this.uploadedDocumentsSubject.next(null);
        this.uploadedDocuments$.subscribe((uploaded)=>{
            if(uploaded) {
                this.myUploadedDocuments = uploaded;
            }
            //this.loadDocumentosSolicitud(this.idSolicitud);
        });

        this.gestiones$ = this.gestionesSubject.asObservable();
        this.gestionesSubject.next(null);

        this.requestService.fetch();
        
        this.paginator = this.requestService.paginator;
        this.tipoGestiones = this.requestService.getTipoGestionPolizasCortas();
        this.estatus = this.requestService.getEstatusPolizasCortas("");
        this.polizas = this.requestService.getListadoPolizas();
        this.sino = this.helperService.getSiNo();
        this.ramos = this.insuranceService.getRamos();
        this.meses = this.insuranceService.getMeses();
        this.anyos = this.insuranceService.getAnyos();
        this.companies = this.helperService.getCompaniaSeguros();
        this.tipoFiltroInteres = this.helperService.getTipoFiltroInteres();

        const sb1 = this.requestService.isLoading$.subscribe(res => this.isLoading = res);
        this.subscriptions.push(sb1);
    }
  
    ngOnDestroy() {
        this.subscriptions.forEach((sb) => sb.unsubscribe());
    }
  
    async clickView(_templateView, id = 0) {
      var _this = this;

        switch ((_templateView)) {
            case 1:
                this.templateView = 1;
            break;
            case 2:
                this.templateView = 2;
                if(id) {
                    this.editRequest(id);
                }
                else {
                    this.resetSubmitRequest();
                }
            break;
        }
    }

    initForm() {

        this.filterPolicyForm = this.fb.group({
            inputMes: [''],
            inputAnyo: [''],
            inputRamo: [''],
            inputSubRamo: [''],
            inputNroDePoliza: [''],
            inputAsegurado: [''],
            inputPlaca: [''],
            inputIdentificacion: [''],
            inputIdCompania: [''],
            inputGrupoEconomico: ['']
        });

        this.filterRequestForm = this.fb.group({
            "inputIdSolicitud":[''],
            "inputProspecto":[''],
            "inputIdEntidadAgencia":[''],
            "inputIdCategoriaSolicitud":[''],
            "inputDescripcion":[''],
            "inputIdEntidadAgente":[''],
            "inputIdEntidadSucursal":[''],
            "inputIdLineaNegocioSolicitud":[''],
            "inputIdPoliza" : [''],
            "inputNroPoliza":[''],
            "inputIdFrecuencia" : [''],
            "inputFrecuencia" : [''],
            "inputPayTo" : [''],
            "inputIdStatus" : [''],
            "inputStatus" : [''],
        });

        this.requestForm = this.fb.group({
            "inputNroSolicitud":[''],
            "inputIdSolicitud":[''],
            "inputProspecto":[''],
            "inputIdEntidadAgencia":[''],
            "inputIdCategoriaSolicitud":['', Validators.compose([])],
            "inputDescripcion":[''],
            "inputIdEntidadAgente":[''],
            "inputIdEntidadSucursal":[''],
            "inputIdLineaNegocioSolicitud":[''],
            "inputIdPoliza" : [''],
            "inputNroPoliza":[''],
            "inputIdFrecuencia" : [''],
            "inputFrecuencia" : [''],
            "inputPayTo" : [''],
            "inputDateCreated" : [''],
            "inputStatus" : [''],
        });

        this.trackingForm = this.fb.group({
            "inputObservacion":[''],
            "inputIdProceso":[{"value" : 1}, Validators.compose([Validators.required])],
            "inputIdDocumento":['', Validators.compose([Validators.required])],
            "inputIdTipoGestion":['', Validators.compose([Validators.required])],
        });

        this.requestDocumentsForm = this.fb.group({
            "inputIdSolicitud":[''],
        });

        this.categorias = this.requestService.getCategoriaSolicitud().then((response)=>{
            if(response) {
                /*
                var selected = _.findWhere(response, { "PorDefecto" : 1 });
                var disabled = _.findWhere(response, { "Modifica" : 1 });
                if(selected) {
                    this.filterRequestForm.patchValue({ "inputIdCategoriaSolicitud" : selected.IdCategoriaSolicitud });
                    if(selected.Modifica == 2) {
                        response = [selected];
                    }
                }
                */
                return Promise.resolve(response);
            }
        });
    }

    resetSubmitFilter() {
      this.filterRequestForm.reset( {"inputNroPoliza" : ""} );
    }

    resetSubmitRequest() {
		this.request_selected = null;
        this.idSolicitud = 0;

		this.newRequest = Promise.resolve(null);
		this.requiredDocumentSubject.next(null);
        this.showDocuments$ =  Promise.resolve(null);
        this.requestDocumentsForm.reset( {"inputIdSolicitud" : ""} );
        this.myUploadedDocuments = null;
        this.agentes = Promise.resolve(null);
        this.categorias = Promise.resolve(null);
        this.sucursales = Promise.resolve(null);
        this.lineanegocios = Promise.resolve(null);
        this.agencias = Promise.resolve(null);
        this.gestionesSubject.next(null);

        this.requestForm.reset({
            "inputNroSolicitud":"",
            "inputIdSolicitud":"",
            "inputProspecto":"",
            "inputIdEntidadAgencia":"",
            "inputIdCategoriaSolicitud":"",
            "inputDescripcion":"",
            "inputIdEntidadAgente":"",
            "inputIdEntidadSucursal":"",
            //"inputIdLineaNegocioSolicitud":"1",
            "inputNroPoliza" : "",
            "inputIdPoliza" : "",
            "inputIdFrecuencia" : "",
            "inputFrecuencia" : "",
            "inputPayTo" : "",
            "inputDateCreated" :  moment(new Date()).format("MM/DD/YYYY"),
            "inputIdStatus" : "",
            "inputStatus" : "",
        });

        this.trackingForm.reset({
            "inputObservacion": "",
            "inputIdProceso": "1",
            "inputIdDocumento": "",
            "inputIdTipoGestion": "",
        });

        this.categorias = this.requestService.getCategoriaSolicitud().then((response)=>{
            if(response) {
                var selected = _.findWhere(response, { "PorDefecto" : 1 });
                var disabled = _.findWhere(response, { "Modifica" : 1 });
                if(selected) {
                    this.requestForm.patchValue({ "inputIdCategoriaSolicitud" : selected.IdCategoriaSolicitud });
                    if(selected.Modifica == 2) {
                        response = [selected];
                    }
                }
                
                return Promise.resolve(response);
            }
        });

        this.sucursales = this.requestService.getSucursal().then((response)=>{
            if(response) {
                var selected = _.findWhere(response, { "PorDefecto" : 1 });
                if(selected) {
                    this.requestForm.patchValue({ "inputIdEntidadSucursal" : selected.IdEntidadSucursal });
                    if(selected.Modifica == 2) {
                        response = [selected];
                    }
                    this.changeAgenciaSucursal({value : selected.IdEntidadSucursal});
                }
                return Promise.resolve(response);
            }
        });

        /*
        this.lineanegocios = this.requestService.getLineaNegocioSolicitud();
        */
        this.agencias = this.requestService.getAgencias().then((response)=>{
            if(response) {
                var selected = _.findWhere(response, { "PorDefecto" : 1 });
                if(selected) {
                    this.requestForm.patchValue({ "inputIdEntidadAgencia" : selected.IdEntidadAgencia });
                    if(selected.Modifica == 2) {
                        response = [selected];
                    }
                    this.changeAgenciaSucursal({value : selected.IdEntidadAgencia});
                }
                return Promise.resolve(response);
            }
        });
        
    }
    
    submitFilterPolicy(content) {
        var paramsGet = Array( 
            `IdEntidad=${this._user.id}`,
            `Asegurado=${this.filterPolicyForm.value.inputAsegurado || ''}`,
            `IdRamo=${this.filterPolicyForm.value.inputRamo || ''}`,
            `IdSubRamo=${this.filterPolicyForm.value.inputSubRamo || ''}`,
            `IdMes=${this.filterPolicyForm.value.inputMes || ''}`,
            `IdAno=${this.filterPolicyForm.value.inputAnyo || ''}`,
            `NroDePoliza=${this.filterPolicyForm.value.inputNroDePoliza || ''}`,
        )

        if(this.permissionMenu.VerGrupoEconomico == 1) {
        paramsGet.push(`GrupoEconomico=${this.filterPolicyForm.value.inputGrupoEconomico || ''}`);
        }

        if(this.permissionMenu.VerCompania == 1) {
            paramsGet.push(`IdCompania=${this.filterPolicyForm.value.inputIdCompania || ''}`);
        }

        this.insuranceService.patchState({ paramsGet : paramsGet.join('&') });
    } 
  
    submitFilterRequest() {
        var paramsGet = "";
//IdEntidadAgente, IdCategoriaSolicitud, IdEntidadAgencia, IdEntidadSucursal, IdLineaNegocioSolicitud, IdSolicitud 
        paramsGet = Array(
            `IdEntidadAgente=${this.filterRequestForm.value.inputIdEntidadAgente||0}`,
            `IdCategoriaSolicitud=${this.filterRequestForm.value.inputIdCategoriaSolicitud||0}`,
            `IdEntidadAgencia=${this.filterRequestForm.value.inputIdEntidadAgencia||0}`,
            `IdEntidadSucursal=${this.filterRequestForm.value.inputIdEntidadSucursal||0}`,
            //`IdLineaNegocioSolicitud=${this.filterRequestForm.value.inputIdLineaNegocioSolicitud||0}`,
            `NroPoliza=${this.filterRequestForm.value.inputNroPoliza}`,
            `Prospecto=${this.filterRequestForm.value.inputProspecto}`,
            `IdSolicitud=${this.filterRequestForm.value.inputIdSolicitud||0}`,
            `Descripcion=${this.filterRequestForm.value.inputDescripcion}`,
        ).join('&');
  
      	this.requestService.patchState({ paramsGet : paramsGet });
    }

    editRequest(id) {
        this.resetSubmitRequest();

        this.myUploadedDocuments = null;
        this.request_selected = this.requestService.extracData(id, this.requestService.items$);
        this.requestService.getGestiones(Array("IdProceso=1", `IdDocumento=${id}`).join("&")).then((response)=>{
            if(response.length) {
                this.gestionesSubject.next(response);
            }
            else {
                this.gestionesSubject.next(null);
            }
        });

        if(this.request_selected) {
            console.log("request_selected", this.request_selected);
            this.idSolicitud = this.request_selected.IdSolicitud;

            this.requestForm.patchValue({
                "inputNroSolicitud": this.request_selected.NroSolicitud,
                "inputIdSolicitud":this.request_selected.IdSolicitud,
                "inputProspecto":this.request_selected.Prospecto,
                
                "inputIdCategoriaSolicitud":this.request_selected.IdCategoriaSolicitud,
                "inputDescripcion":this.request_selected.Descripcion,
                "inputIdEntidadAgente":this.request_selected.IdEntidadAgente,
                
                //"inputIdLineaNegocioSolicitud":this.request_selected.IdLineaNegocioSolicitud,
                "inputNroPoliza" : this.request_selected.NroDePoliza,
                "inputIdPoliza" : this.request_selected.IdPoliza,
                "inputFrecuencia" : this.request_selected.FrecuenciaDePagos,
                "inputIdFrecuencia" : this.request_selected.IdFrecuenciaPago,
                "inputPayTo" : moment(this.request_selected.FechaPayTo, "YYYY-MM-DD").format("MM/DD/YYYY"),
                "inputDateCreated" : moment(this.request_selected.FechaCreacion, "YYYY-MM-DD").isValid() ? moment(this.request_selected.FechaCreacion, "YYYY-MM-DD").format("MM/DD/YYYY") : "",
                "inputStatus" : this.request_selected.Estatus
            });

            if(this.request_selected.IdEntidadAgencia) {
                this.requestForm.patchValue({ "inputIdEntidadAgencia":this.request_selected.IdEntidadAgencia });
            }
            else if(this.request_selected.IdEntidadSucursal) {
                this.requestForm.patchValue({ "inputIdEntidadSucursal":this.request_selected.IdEntidadSucursal });
            }

            this.trackingForm.patchValue({
                "inputIdDocumento": this.request_selected.IdSolicitud,
            });
            
            this.showDocuments$ = Promise.resolve(true);
            this.uploadedDocuments(this.idSolicitud);
            this.loadDocumentosSolicitud(this.idSolicitud);
        }
    }

    submitTracking(content) {
        var g = this;

        if(this.trackingForm.valid && this.request_selected.IdSolicitud) {
            this.modalLoading.open(content, this.loadingModalConfig);
            this.trackState = TrackStates.NoError;

            var params = [{
                "IdDocumento":this.request_selected.IdSolicitud.toString(),
                "IdProceso":"1",
                "IdTipoGestion":this.trackingForm.value.inputIdTipoGestion.toString(),
                "Observacion":this.trackingForm.value.inputObservacion.trim(),
            }];

            this.showGestiones = this.requestService.postGestiones(params).then((response:any) => {
                if(_.size(response[0])) {
                    this.trackingForm.reset({
                        "inputObservacion": "",
                        "inputIdProceso": "1",
                        "inputIdDocumento": g.request_selected.IdSolicitud,
                        "inputIdTipoGestion": "",
                    });

                    g.requestService.getGestiones(Array("IdProceso=1", `IdDocumento=${g.request_selected.IdSolicitud}`).join("&")).then((response)=>{
                        this.gestionesSubject.next(response);
                    });

                    return Promise.resolve(response);
                }
            }).finally(()=> {
				g.modalLoading.dismissAll();
			}).catch((reason: any)=>{
                this.trackState = TrackStates.HasError;
            })
        }
        else {
            this.trackState = TrackStates.HasError;
            g.modalLoading.dismissAll();
        }
    }

    onclickProcessRequest(content) {
        var g = this;
        //this.request_selected = this.requestService.extracData(this.request_selected, this.requestService.items$);

        if(this.request_selected) {
            g.modalProcess.dismissAll();
            g.modalLoading.open(content, this.loadingModalConfig);

            this.idSolicitud = this.request_selected.IdSolicitud;
            var params = [{
                "IdSolicitud" : this.requestForm.value.inputIdSolicitud || null,
                "IdEntidadAgente" : this.requestForm.value.inputIdEntidadAgente || null,
                "IdCategoriaSolicitud" : this.requestForm.value.inputIdCategoriaSolicitud || null,
                "IdEntidadAgencia" : this.requestForm.value.inputIdEntidadAgencia || null,
                "IdEntidadSucursal" : this.requestForm.value.inputIdEntidadSucursal || null,
                "IdPoliza" : parseInt(this.requestForm.value.inputIdPoliza) || null,
                "Prospecto" : this.requestForm.value.inputProspecto || null,
                "Descripcion" : this.requestForm.value.inputDescripcion || null,
                //"IdLineaNegocioSolicitud" : this.requestForm.value.inputIdLineaNegocioSolicitud || null,
                "IdFrecuencia" : this.requestForm.value.inputIdFrecuencia || null,
                "FrecuenciaDePagos" : this.requestForm.value.inputFrecuencia.trim() || null,
                "PayTo" : moment(this.requestForm.value.inputPayTo, "MM/DD/YYYY").format("YYYY-MM-DD") || null,
                "FechaCreacion" : moment(this.requestForm.value.inputDateCreated, "MM/DD/YYYY").format("YYYY-MM-DD") || null,
                "Type" : "P"
            }];
            this.showDocuments$ = this.requestService.postProcesarSolicitudPolizaCorta(params).then((response:any) => {
                if(_.size(response[0])) {
                    
                }
            }).finally(()=> {
				g.modalLoading.dismissAll();
			}).catch((reason: any)=>{
                this.errorState = ErrorStates.HasError;
            });
        }
    }

    showDocuments() {

    }

    submitRequest(content, type) {
        var g = this;
        this.idSolicitud = null;

        if(this.requestForm.valid && moment(this.requestForm.value.inputPayTo, "MM/DD/YYYY").isValid()) {
            this.modalLoading.open(content, this.loadingModalConfig);

            var params = [{
                "IdSolicitud" : this.requestForm.value.inputIdSolicitud || null,
                "IdEntidadAgente" : this.requestForm.value.inputIdEntidadAgente || null,
                "IdCategoriaSolicitud" : this.requestForm.value.inputIdCategoriaSolicitud || null,
                "IdEntidadAgencia" : this.requestForm.value.inputIdEntidadAgencia || null,
                "IdEntidadSucursal" : this.requestForm.value.inputIdEntidadSucursal || null,
                "IdPoliza" : parseInt(this.requestForm.value.inputIdPoliza) || null,
                "Prospecto" : this.requestForm.value.inputProspecto || null,
                "Descripcion" : this.requestForm.value.inputDescripcion || null,
                //"IdLineaNegocioSolicitud" : this.requestForm.value.inputIdLineaNegocioSolicitud || null,
                "IdFrecuencia" : this.requestForm.value.inputIdFrecuencia || null,
                "FrecuenciaDePagos" : this.requestForm.value.inputFrecuencia.trim() || null,
                "PayTo" : moment(this.requestForm.value.inputPayTo, "MM/DD/YYYY").format("YYYY-MM-DD") || null,
                "FechaCreacion" : moment(this.requestForm.value.inputDateCreated, "MM/DD/YYYY").format("YYYY-MM-DD") ||  moment(new Date()).format("YYYY-MM-DD"),
                "Type" : type
            }];

            // postCrearSolicitudPolizaCorta
            this.showDocuments$ = this.requestService.postCrearSolicitudPolizaCorta(params).then((response:any) => {
                if(_.size(response[0])) {
                    this.request_selected = response[0];
                    this.requestForm.patchValue({ 
                        "inputIdSolicitud" : (g.idSolicitud = response[0].IdSolicitud),
                        "inputNroSolicitud" : (g.nroSolicitud = response[0].NroSolicitud),
                        "inputStatus" :  "SUBMITTED"
                    });

                    this.trackingForm.patchValue({
                        "inputIdDocumento": response[0].IdSolicitud,
                    });

                    this.requestService.getGestiones(Array("IdProceso=1", `IdDocumento=${response[0].IdSolicitud}`).join("&")).then((response)=>{
                        if(response.length) {
                            this.gestionesSubject.next(response);
                        }
                        else {
                            this.gestionesSubject.next(null);
                        }
                    });

                    this.loadDocumentosSolicitud(response[0].IdSolicitud);
                    this.uploadedDocuments(response[0].IdSolicitud);

                    g.errorState = ErrorStates.HasSuccess;
                    g.submitFilterRequest();

                    if(type=="P") {
                        this.clickView(1);
                        this.request_selected = null;
                    }

                    return Promise.resolve(true);
                }
                else {
                    g.errorState = ErrorStates.HasError;
                    return Promise.resolve(null);
                }
            }).finally(()=> {
				g.modalLoading.dismissAll();
			}).catch((reason: any)=>{
                this.errorState = ErrorStates.HasError;
            });
        }
        else {
            this.errorState = ErrorStates.HasError;
        }
    }

    onclickModalSearchPolicie(idSolicitud, content) {
        this.modalFilterPolicie.open(content, this.largeModalConfig);
    }

    submitFilterPolice() {
        var params = Array(
            `IdEntidadAgente=${this.requestForm.value.inputIdEntidadAgente||0}`,
            `IdCategoriaSolicitud=${this.requestForm.value.inputIdCategoriaSolicitud||0}`,
            `IdEntidadAgencia=${this.requestForm.value.inputIdEntidadAgencia||0}`,
            `IdEntidadSucursal=${this.requestForm.value.inputIdEntidadSucursal||0}`,
            //`IdLineaNegocioSolicitud=${this.requestForm.value.inputIdLineaNegocioSolicitud||0}`,
            `IdSolicitud=${this.requestForm.value.inputIdSolicitud||0}`,
        ).join('&');

        this.insuranceService.patchState({paramsGet : Array("").join('&')});
    }

    onclickSelectPolicy(item) {
        this.requestForm.patchValue({
            "inputIdPoliza" : item.IdPoliza,
            "inputNroPoliza" : item.NroDePoliza,
            "inputProspecto" : item.Asegurado,
            "inputFrecuencia" : item.FrecuenciaDePagos,
            "inputIdFrecuencia" : item.IdFrecuenciaPago,
            "inputPayTo" :  moment(item.PayTo).format("MM/DD/YYYY") || '',
        });

        this.modalFilterPolicie.dismissAll();
    }


    loadDocumentosSolicitud(idSolicitud) {
        this.docRequestService.patchState({paramsGet : Array("IdSolicitud=" + idSolicitud).join('&')});
        
    }

    onclickModalProcesRequest(id, content) {
        this.hasLoadindRD = true;
        this.request_selected = this.requestService.extracData(id, this.requestService.items$);
        console.log(this.request_selected );
        this.modalProcess.open(content, this.loadingModalConfig);
    }

    onclickModalStatus(id, content) {
        var g = this;

        g.gestionesSubject.next(null);

        this.requestService.getGestiones(Array("IdProceso=1", `IdDocumento=${id}`).join("&")).then((response)=>{
            if(response.length) {
                g.gestionesSubject.next(response);
            }
            else {
                g.gestionesSubject.next(null);
            }
        }).catch(()=>{
            g.gestionesSubject.next(null);
        });

        this.modalTracking.open(content, this.largeModalConfig);
    }

    onModalViewTracking(content, tracking) {
        this.tracking_selected = tracking;
        this.modalTracking.open(content, this.loadingModalConfig);
    }

    onViewDocument(content, IdDocCargados=0) {
		var g = this;
		if(IdDocCargados > 0) {
			g.modalLoading.open(content, this.loadingModalConfig);

			this.requestService.getDescargarDocumentoSolicitudCorta(`IdSolicitud=${this.idSolicitud}&IdDocCargados=${IdDocCargados}`).then(response => {
				if(typeof(response[0].Documento) != "undefined") {
/*
                    this.helperService.printPreview3(`${response[0].Documento}`, response[0].NameDoc);
                    return true;
*/

					const linkSource = `data:application/pdf;base64,${response[0].Documento}`;

                    this.helperService.forceDowndload(linkSource, response[0].NameDoc)

					//const downloadLink = (document.getElementById("download-file") as HTMLLinkElement);
					//downloadLink.href = linkSource;
					//downloadLink.title = response[0].NameDoc;
                    //downloadLink.click();
                    //setTimeout(()=>{  downloadLink.click(); }, 500);
				}
				else {
					alert("No se pudo descarga el documento.")
				}
			}).finally(()=> {
				g.modalLoading.dismissAll();   
			});
		}
    }

    onclickUploadRequiredDocument(content, item) {
		if( ! (document.getElementById(`file${item.IdTipoDocumento}`) as HTMLInputElement).files[0] ) {
            alert("Debe seleccionar un documento para poder subirlo.");
        }
        else {
            this.doc1States = DocStates.UploadingDocument;
            this.modalStatus.open(content, this.loadingModalConfig);

            var params = {
                "IdSolcitud" : this.requestForm.value.inputIdSolicitud,
                "IdTipoDocumento" : item.IdTipoDocumento,
                "file" : `file${item.IdTipoDocumento}`,
                "Descripcion" : item.MultipleCarga ? `description${item.IdTipoDocumento}` : ''
            };

            this.requestService.postCargarDocumentoSolicitudCorta(params).then(response => {
                if(response) {
                    this.doc1States = DocStates.NoError;
                    this.uploadedDocuments(this.idSolicitud);
                    this.loadDocumentosSolicitud(this.idSolicitud);
                }
                else {
                    this.doc1States = DocStates.HasError;
                }
            }).finally(() => {
                this.modalStatus.dismissAll();
            }).catch(() => {
                this.doc1States = DocStates.HasError;
            });
        }
    }

    uploadedDocuments(idSolicitud) {
        this.doc2States = DocStates.LoadingUploadedDocuments;
        this.requestService.getDocumentosCargados("IdSolicitud=" + idSolicitud).then(response => {
            if(response.length) {
                this.doc2States = DocStates.NoError;
                this.uploadedDocumentsSubject.next(response);
                return Promise.resolve(response);
            }
            else {
                this.doc2States = DocStates.HasEmpty;
            }
        }).finally(()=>{

        }).catch(() => {

        });
    }

    hideRequiredDocument(item) {
		item.pipe().subscribe(items => {
		  return items.filter(c => {
			if(c.MultipleCarga == 1) {
			  
			}
		  });
		});
			
		return item;
	}

    preUpload(event, IdTipoDocumento) {
        let file = event.target.files[0];
        if (event.target.files.length > 0){
            (document.getElementById(`custom-file-label-${IdTipoDocumento}`) as HTMLInputElement).innerText = file.name;
        }
    }

    changeFilterMode(event) {
        this.insuredFilter = event.target.value;
    }
    
    changeRamo(event) {
        this.subramos = this.insuranceService.getSubRamos("IdRamo=" + event.target.value).finally(() => {
            this.IdRamo = event.target.value > 0 ? event.target.value : false;
        });
    }

    changeFilterCategoria($target, filter = true) {
        var id = 0;
        
        if($target) {
            id = $target.value;
        }
        else {
            id = this.request_selected.IdCategoriaSolicitud;
        }
        if(id == 1) {
            this.agencias = this.requestService.getAgencias().then((response)=>{
                if(response) {
                    if(filter) {
                        var selected = _.findWhere(response, { "PorDefecto" : 1 });
                        if(selected) {
                            this.filterRequestForm.patchValue({ "inputIdEntidadAgencia" : selected.IdEntidadAgencia });
                            if(selected.Modifica == 2) {
                                response = [selected];
                            }
                            this.changeAgenciaSucursal({value : selected.IdEntidadAgencia});
                        }
                        else {
                            this.filterRequestForm.patchValue({ "inputIdEntidadAgencia" : '' });
                        }
                    }
                    return Promise.resolve(response);
                }
            });
        }
        else if(id == 2) {
            this.sucursales = this.requestService.getSucursal().then((response)=>{
                if(response) {
                    if(filter) {
                    var selected = _.findWhere(response, { "PorDefecto" : 1 });
                        if(selected) {
                            this.filterRequestForm.patchValue({ "inputIdEntidadSucursal" : selected.IdEntidadSucursal });
                            if(selected.Modifica == 2) {
                                response = [selected];
                            }
                            this.changeAgenciaSucursal({value : selected.IdEntidadSucursal});
                        }
                    }
                    else {
                        this.filterRequestForm.patchValue({ "inputIdEntidadSucursal" : '' });
                    }
                    return Promise.resolve(response);
                }
            });
        }
        else {
            this.filterRequestForm.patchValue({ "inputIdEntidadAgencia" : '' });
            this.filterRequestForm.patchValue({ "inputIdEntidadSucursal" : '' });
            this.filterRequestForm.patchValue({ "inputIdEntidadAgente" : '' });
        }
    }

    changeCategoria($target, filter = true) {
        var id = 0;
        
        if($target) {
            id = $target.value;
        }
        else {
            id = this.request_selected.IdCategoriaSolicitud;
        }

        if(id == 1) {
            this.agencias = this.requestService.getAgencias().then((response)=>{
                if(response) {
                    if(filter) {
                        var selected = _.findWhere(response, { "PorDefecto" : 1 });
                        if(selected) {
                            this.requestForm.patchValue({ "inputIdEntidadAgencia" : selected.IdEntidadAgencia });
                            if(selected.Modifica == 2) {
                                response = [selected];
                            }
                            this.changeAgenciaSucursal({value : selected.IdEntidadAgencia});
                        }
                        else {
                            this.requestForm.patchValue({ "inputIdEntidadAgencia" : '' });
                        }
                    }
                    return Promise.resolve(response);
                }
            });
        }
        else if(id == 2) {
            this.sucursales = this.requestService.getSucursal().then((response)=>{
                if(response) {
                    if(filter) {
                    var selected = _.findWhere(response, { "PorDefecto" : 1 });
                        if(selected) {
                            this.requestForm.patchValue({ "inputIdEntidadSucursal" : selected.IdEntidadSucursal });
                            if(selected.Modifica == 2) {
                                response = [selected];
                            }
                            this.changeAgenciaSucursal({value : selected.IdEntidadSucursal});
                        }
                    }
                    else {
                        this.requestForm.patchValue({ "inputIdEntidadSucursal" : '' });
                    }
                    return Promise.resolve(response);
                }
            });
        }
        else {
            this.requestForm.patchValue({ "inputIdEntidadAgencia" : '' });
            this.requestForm.patchValue({ "inputIdEntidadSucursal" : '' });
            this.requestForm.patchValue({ "inputIdEntidadAgente" : '' });
        }
    }

    changeAgenciaSucursal($target) {
        var filter = 0;
        
        if($target) {
            filter = $target.value;
        }
        else {
            filter = this.request_selected.IdEntidadAgencia || this.request_selected.IdEntidadSucursal;
        }
        
        if(filter) {
            this.agentes = this.requestService.getAgentes(`IdEntidadAgenciaSucursal=${filter}`).then((response) => {
                if(response) {
                    var selected =  null;
                    if($target) {
                        selected = _.findWhere(response, { "PorDefecto" : 1 });
                    }
                    else {
                        selected = _.findWhere(response, { "IdEntidadAgente" : this.request_selected.IdEntidadAgente });
                    }

                    if(selected) {
                        this.requestForm.patchValue({ "inputIdEntidadAgente" : selected.IdEntidadAgente });
                        if(selected.Modifica == 2) {
                            response = [selected];
                        }
                    }
                    return Promise.resolve(response);
                }
            });
        }
        else {
            this.agentes =  Promise.resolve(null);
        }
    }

    isUplodadedDocument(id) {
        if(id == 1 && this.myUploadedDocuments) { // Los requeridos
        var item = _.findWhere(this.myUploadedDocuments, { "IdTipoDocumento" : id});
        console.log(item.IdTipoDocumento == 1 ? false : true);
        return item.IdTipoDocumento == 1 ? false : true;
        }
        return true;
    }
}
